<template>
  <form @change="logChangeData">
    <div class="setting_content">
      <div class="setting_content_main">
        <h2 class="setting_content_title">{{ labelProperties.HEAD_TITLE }}</h2>
        <div class="setting_unit">
          <p class="setting_unit_title">{{ labelProperties.SEARCH_SCREEN }}</p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ labelProperties.LABEL_BUTTON }}</p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="labelProperties.PLACE_HOLDER_SEARCH_SCREEN"
                v-model="button.searchBtn"
                @change="validateSearchBtn"
              />
              <p v-if="isSearchBtnError" class="error_msg">
                {{ maxlengthProperties.MAX_LENGTH_BUTTON
                }}{{ maxlengthMessageProperties.MESSAGE_MAX_LENGTH }}
              </p>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">{{ labelProperties.LIST_SCREEN }}</p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ labelProperties.LABEL_BUTTON }}</p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="labelProperties.PLACE_HOLDER_LIST_SCREEN"
                v-model="button.listBtn"
                @change="validateListBtn"
              />
              <p v-if="isListBtnError" class="error_msg">
                {{ maxlengthProperties.MAX_LENGTH_BUTTON
                }}{{ maxlengthMessageProperties.MESSAGE_MAX_LENGTH }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ advanceSettingProperties.PRINT_BUTTON }}</p>
            <div class="setting_unit_form">
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySettingJobList.print"
                    value="true"
                    id="is_print_list_0"
                    checked="checked"
                />
                <label for="is_print_list_0" class="setting_form_radio_text">
                  {{ advanceSettingProperties.DISPLAY }}
                </label>
              </label>
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySettingJobList.print"
                    value="false"
                    id="is_print_list_1"
                />
                <label for="is_print_list_1" class="setting_form_radio_text">
                  {{ advanceSettingProperties.NOT_DISPLAY }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">{{ labelProperties.DETAIL_SCREEN }}</p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.LABEL_DETAIL_BUTTON }}
            </p>
            <div class="setting_unit_form">
              <input
                  class="setting_form_text"
                  type="text"
                  :placeholder="labelProperties.PLACE_HOLDER_DETAIL_SCREEN"
                  v-model="button.detailBtn"
                  @change="validateDetailBtn"
              />
              <p v-if="isDetailBtnError" class="error_msg">
                {{ maxlengthProperties.MAX_LENGTH_BUTTON
                }}{{ maxlengthMessageProperties.MESSAGE_MAX_LENGTH }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.LABEL_CONTACT_BUTTON }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="labelProperties.PLACE_HOLDER_CONTACT_SCREEN"
                v-model="button.contactBtn"
                @change="validateContactBtn"
              />
              <p v-if="isContactBtnError" class="error_msg">
                {{ maxlengthProperties.MAX_LENGTH_BUTTON
                }}{{ maxlengthMessageProperties.MESSAGE_MAX_LENGTH }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ advanceSettingProperties.PRINT_BUTTON }}</p>
            <div class="setting_unit_form">
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySettingJobDetail.print"
                    value="true"
                    id="is_print_detail_0"
                    checked="checked"
                />
                <label for="is_print_detail_0" class="setting_form_radio_text">
                  {{ advanceSettingProperties.DISPLAY }}
                </label>
              </label>
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySettingJobDetail.print"
                    value="false"
                    id="is_print_detail_1"
                />
                <label for="is_print_detail_1" class="setting_form_radio_text">
                  {{ advanceSettingProperties.NOT_DISPLAY }}
                </label>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import labelProperties from "../../../../properties/job_screen/button_tab/button-setting-labels.json";
import maxlengthProperties from "../../../../properties/job_screen/button_tab/button-maxlength.json";
import maxlengthMessageProperties from "../../../../properties/job_screen/button_tab/button-message.json";
import AdvanceSettingProperties from "../../../../properties/entry_screen/advance_setting_tab/advance-setting-labels.json";

Vue.use(VueToast);

export default {
  name: "ButtonTab",
  props: ["button", "buttonError", "displaySettingJobList", "displaySettingJobDetail"],
  data: function () {
    return {
      isSearchBtnError: false,
      isListBtnError: false,
      isDetailBtnError: false,
      isContactBtnError: false,
      labelProperties: labelProperties,
      maxlengthProperties: maxlengthProperties,
      maxlengthMessageProperties: maxlengthMessageProperties,
      advanceSettingProperties: AdvanceSettingProperties
    };
  },
  watch:{ 
    button:{
      handler:function() {
        this.validateSearchBtn();
        this.validateListBtn();
        this.validateDetailBtn();
        this.validateContactBtn();
      },
      deep: true
    }
  },
  computed: {
    computedButtonError: {
      get() {
        return this.buttonError;
      },
      set(val) {
        this.$emit("updatedButtonError", val);
      },
    },
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },
    validateSearchBtn() {
      if(this.button.searchBtn){
        this.isSearchBtnError =
          this.button.searchBtn.length > maxlengthProperties.MAX_LENGTH_BUTTON;
      }else{
        this.isSearchBtnError = false;
      }
      this.checkError();
    },

    validateListBtn() {
      if(this.button.listBtn){
        this.isListBtnError =
          this.button.listBtn.length > maxlengthProperties.MAX_LENGTH_BUTTON;
      }else{
        this.isListBtnError = false;
      }

      this.checkError();
    },

    validateDetailBtn() {
      if(this.button.detailBtn){
        this.isDetailBtnError =
          this.button.detailBtn.length > maxlengthProperties.MAX_LENGTH_BUTTON;
      }else{
        this.isDetailBtnError = false;
      }
      this.checkError();
    },

    validateContactBtn() {
      if(this.button.contactBtn){
        this.isContactBtnError =
          this.button.contactBtn.length > maxlengthProperties.MAX_LENGTH_BUTTON;
      }else{
        this.isContactBtnError = false;
      }
      this.checkError();
    },

    checkError() {
      this.computedButtonError =
        this.isSearchBtnError ||
        this.isListBtnError ||
        this.isDetailBtnError ||
        this.isContactBtnError;
    },
  },
};
</script>

<style scoped>
.error_msg {
  color: #f16a6a;
  font-size: 14px;
  font-weight: 500;
}
</style>
